import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  async getStoreDetails (storeId) {
    Logger.info('Started Get Store Details query.')
    return tmxApiCall('get', '/store', {
      params: {
        storeId
      }
    })
  },

  async getStoreMapImage (storeId, address) {
    Logger.info('Started Get Store Map query.')
    return tmxApiCall('get', '/storemap', {
      params: {
        storeId,
        storeAddress: address
      }
    }).then(data => `data:image/png;base64,${data}`)
  },

  async notifyOnStateAvailable (username, state) {
    Logger.info('Started save notify info.')
    return tmxApiCall('post', '/notificationinfo', {
      Contact: username,
      State: state
    })
  },

  /**
   * Gets the next business date (skipping weekends and holidays). Supports NLS only currently.
   * @param {String} lmsId - The LMS ID to get the business date for.
   * @returns {Promise<String>} The next business date in the format "YYYY-MM-DD".
   */
  async getNextBusinessDate (lmsId) {
    Logger.info('Starting Get Next Business Date query.')
    return tmxApiCall('get', '/nextBusinessDate', {
      params: {
        lmsId
      }
    })
  }
}
